import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

// material-ui
import { useTheme } from '@mui/material/styles'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material'
import { ArchiveOutlined, UnarchiveOutlined } from '@mui/icons-material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { useSetState } from '@contenthouse/hooks'

import useProject from 'hooks/useProject'
import { getApiErrorMessage } from 'shared/functions/errors'

// ==============================|| PROJECT ARCHIVED ||============================== //

const defaultState = {
  openUnarchive: false,
}

const ProjectArchived = (props) => {
  const { t } = useTranslation('layout')
  const { project, callbacks } = props
  const { toggleUnarchiveSuccess } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { openUnarchive } = state

  const theme = useTheme()

  const {
    callbacks: { patchProject: patchFn },
    updating,
  } = useProject()

  const unarchive = () => {
    patchFn({ id: project.id, archive_date: null }).then(({ success, errors }) => {
      if (!success && errors) {
        toast.warn(getApiErrorMessage(errors))
        return
      }
      setUnarchive(false)
      if (toggleUnarchiveSuccess)
        toggleUnarchiveSuccess()
    })
  }

  const setUnarchive = (val) => {
    setState({ openUnarchive: val })
  }

  return (
    <>
      <Stack direction="column" spacing={0.5} sx={{ alignItems: 'center', textAlign: 'center', py: 5, px: 2 }}>
        <ArchiveOutlined sx={{ fontSize: 60 }} />
        <Typography variant="h4" sx={{ pt: 1.5 }}>
          {t('projectArchived.title')}
        </Typography>
        <Typography variant="body1">
          {t('projectArchived.body1')}
        </Typography>
        <Typography variant="body1" sx={{ pb: 1.5 }}>
          {t('projectArchived.body2')}
        </Typography>
        <Button
          variant="contained"
          disableElevation
          onClick={() => setUnarchive(true)}
          sx={{
            transition: 'all .2s ease-in-out',
            background: theme.palette.primary.light,
            color: theme.palette.primary.dark,
            '&[aria-controls="menu-list-grow"],&:hover': {
              background: theme.palette.primary.dark,
              color: theme.palette.primary.light,
            },
          }}
        >
          <Typography variant="buttonText" sx={{ textTransform: 'none' }}>
            {t('projectArchived.unarchive')}
          </Typography>
        </Button>
      </Stack>
      <Dialog
        open={openUnarchive}
        onClose={() => setUnarchive(false)}
        sx={{
          '& .MuiDialogTitle-root': { fontSize: '1.25rem!important' },
        }}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle sx={{ borderBottom: 1, marginBottom: 1, borderColor: theme.palette.primary.light }}>
          <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between' }}>
            <Typography variant="h4" sx={{ fontWeight: 500 }}>
              {t('projectArchivedConfirm.title')}
            </Typography>
            <CloseOutlinedIcon fontSize="small" sx={{ cursor: 'pointer' }} onClick={() => setUnarchive(false)} />
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center' }}>
          <UnarchiveOutlined sx={{ fontSize: 80 }} />
          <Typography variant="h4" sx={{ py: 1 }}>
            {t('projectArchivedConfirm.areYouSure')}
          </Typography>
          <DialogContentText>{t('projectArchivedConfirm.body1')}</DialogContentText>
          <DialogContentText>{t('projectArchivedConfirm.body2')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUnarchive(false)}>{t('projectArchivedConfirm.cancel')}</Button>
          <Button loading={updating} variant="contained" disableElevation onClick={() => unarchive()}>
            {t('projectArchivedConfirm.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ProjectArchived
